import { Component, OnInit, Input, Output, EventEmitter, ElementRef, AfterViewInit } from '@angular/core';

@Component({
    selector: 'tam-audit-trail-username',
    templateUrl: './audit-trail-username.component.html',
    styleUrls: ['./audit-trail-username.component.scss']
})
export class AuditTrailUsernameComponent implements OnInit, AfterViewInit {

    @Output() viewDetail = new EventEmitter<any>();
    @Input() data: any;

    title = '';

    constructor(
        private elementRef: ElementRef
    ) { }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            if (this.elementRef.nativeElement.clientWidth >= 300) {
                this.title = this.data.userName;
            } else {
                this.title = '';
            }
        });
    }

}
